<template>
  <div>
    <v-data-table
      id="tabela_listaGrupos"
      :headers="tableHeaders"
      :items="listaGrupoFornecedores"
      :no-data-text="$t('label.tabela_sem_conteudo')"
      :disable-pagination="true"
      :hide-default-footer="true">

      <template v-slot:[`item.deletar`]="{ item }">
        <v-btn :disabled="item.desabilitaDeletar || somenteLeitura || desabilitarCadastroFornecedor"
          icon @click="removerLinhaGrupoFornecedor(item)">
          <v-icon>delete</v-icon>
        </v-btn>
      </template>

      <template v-slot:[`item.nomesCnpjsFormatados`]="{ item }">
        <div style="white-space: pre-wrap;">{{ item.nomesCnpjsFormatados }}</div>
      </template>

      <template v-slot:[`item.documentacao`]="{ item }" v-if="isRepresentanteLegal">
        <v-btn
          depressed
          color="primary"
          :disabled="somenteLeitura || isNovoCadastro"
          class="btn-tabela-custom"
          small
          @click="$emit('abrirModalAnexos', item)">
          <v-icon color="white">attach_file</v-icon>
        </v-btn>
      </template>

      <template v-slot:[`item.representacaoConjunto`]="{ item }" v-if="isRepresentanteLegal">
        <v-btn
          v-if="item.indPossuiRepresentacaoConjunto"
          depressed
          color="primary"
          class="btn-tabela-custom"
          small
          @click="$emit('abrirModalRepresentacao', item)">
          <v-icon color="white">visibility</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'UsuarioGrupoFornecedorList',
  props: {
    somenteLeitura: Boolean,
    desabilitarCadastroFornecedor: {
      type: Boolean,
      default: false,
    },
    listaGrupoFornecedores: {
      type: Array,
      default: () => ([]),
    },
    isRepresentanteLegal: {
      type: Boolean,
      default: false,
    },
    isNovoCadastro: {
      type: Boolean,
      default: false,
    },
    isRepresentacaoConjunto: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: '', value: 'deletar', sortable: false, align: 'center', width: '5%',
        },
        {
          text: this.$tc('label.grupo_fornecedor', 1), value: 'nomExtensao', sortable: true, width: '20%',
        },
        {
          text: this.$tc('label.cnpj_tax_id', 1), value: 'nomesCnpjsFormatados', sortable: true, width: '35%',
        },
      ],
    };
  },
  methods: {
    removerLinhaGrupoFornecedor(item) {
      const index = this.listaGrupoFornecedores.indexOf(item);
      if (index > -1) {
        this.listaGrupoFornecedores.splice(index, 1);
      }
    },
  },
  computed: {
    tableHeaders() {
      const headers = Array.isArray(this.headers) ? [...this.headers] : [];
      if (this.isRepresentanteLegal) {
        headers.push(
          {
            text: this.$tc('label.documentacao', 1),
            value: 'documentacao',
            sortable: false,
            align: 'center',
            width: '10%',
          },
        );
        if (this.isRepresentacaoConjunto) {
          headers.push(
            {
              text: this.$tc('label.representacao_conjunto', 1),
              value: 'representacaoConjunto',
              sortable: false,
              align: 'center',
              width: '10%',
            },
          );
        }
      }
      return headers;
    },
  },
};
</script>
<style scoped>
.btn-tabela-custom {
  border-radius: 4px !important;
  min-width: 44px !important;
  height: 32px !important;
}
</style>
